export const routes = (parentName) => {
  return [
    {
      path: "referrals",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Referrals`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Referrals-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Referrals-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Referrals-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
